import styled from 'styled-components'

const Style = {
	Container: styled.div`
		display: flex;
		width: 100%;
		align-items: center;
		border-radius: 8px;
		background-color: ${({theme}) => theme.color.black || '#1F2024'};
		padding: 20px;

		/* Alternative: Use transform for consistent spacing across browsers */
		/* transform: translateY(35px); */
		/* Ensure consistent box model */
		box-sizing: border-box;
	`,

	InfoSection: styled.div`
		display: flex;
		width: 75%;
		align-items: center;

		gap: 8px;
	`,

	Nickname: styled.p`
		${({theme}) => theme.font.extra_small || theme.font.small};
		color: ${({theme}) => theme.color.white || '#FFFFFF'};
		font-size: 8px;
		font-weight: 400;
		line-height: 1.2;
		margin: 0;
	`,

	AvatarSection: styled.div`
		display: flex;
		flex-direction: column;
		justify-content: center;
		gap: 8px;
		width: fit-content;
		margin-right: 8px;
	`,

	Avatar: styled.img`
		width: 36px;
		height: 36px;
		object-fit: cover;
		border-radius: 9999999px;
		overflow: hidden;
	`,

	DetailsSection: styled.div`
		${({theme}) => theme.font.small || theme.font.medium};
		color: ${({theme}) => theme.color.white || '#FFFFFF'};
		font-size: 12px;
		font-weight: 400;
		line-height: 1.2;
	`,

	QualificationSection: styled.div`
		display: flex;
		justify-content: flex-end;
	`,

	NameRow: styled.div`
		display: flex;
		align-items: center;
		gap: 8px;
	`,

	Name: styled.p`
		${({theme}) => theme.font.small_bold || theme.font.small};
		color: ${({theme}) => theme.color.white || '#FFFFFF'};
		font-size: 12px;
		font-weight: 700;
		line-height: 1.2;
		margin: 0;
	`,

	PhoneNumber: styled.p`
		${({theme}) => theme.font.small || theme.font.medium};
		color: ${({theme}) => theme.color.white || '#FFFFFF'};
		font-size: 12px;
		font-weight: 400;
		line-height: 1.2;
		margin: 0;
		/* Disable Chrome's automatic phone number detection */
		-webkit-text-size-adjust: 100%;
		-webkit-touch-callout: none;
		-webkit-user-select: none;
		-khtml-user-select: none;
		-moz-user-select: none;
		-ms-user-select: none;
		user-select: none;
	`,

	PlayerId: styled.p`
		${({theme}) => theme.font.small || theme.font.medium};
		color: ${({theme}) => theme.color.white || '#FFFFFF'};
		font-size: 12px;
		font-weight: 400;
		line-height: 1.2;
		margin: 0;
	`,

	QualificationBadge: styled.div`
		${({theme}) => theme.font.small || theme.font.medium};
		background-color: ${({theme}) => theme.color.white || '#FFFFFF'};
		padding: 4px 6px;
		color: ${({theme}) => theme.color.black || '#1F2024'};
		font-size: 12px;
		font-weight: 400;
		line-height: 1.2;
		width: fit-content;
		border-radius: 9999px;
	`,

	QualificationText: styled.span`
		${({theme}) => theme.font.small || theme.font.medium};
		color: ${({theme}) => theme.color.black || '#1F2024'};
		font-size: 12px;
		font-weight: 400;
		line-height: 1.2;
	`,
}

export default Style
